module.exports = __webpack_public_path__ + "img/stateminister.ef34fd7f.jpg";